import { useState } from "react";
import { useUser } from "../../contexts/UserContext";
import FetchWrapper from "../../components/UI/FetchWraper";
import CategorizedQuestionsList from "./SuggestedQuestions/CategorizedQuestionsList";
import AskVivoHeader from "./AskVivoHeader";
import { useScopeParams } from "../../hooks/useScopeParams";

interface ChatCoverProps {
  handleSuggestedQuestions: (question: string) => void;
}

export default function ChatCover({
  handleSuggestedQuestions,
}: ChatCoverProps) {
  const { userInfo } = useUser();
  const { scope } = useScopeParams();
  const [isAskVivoHeaderVisible, setIsAskVivoHeaderVisible] = useState(true);

  const hideAskVivoHeader = () => {
    setIsAskVivoHeaderVisible(false);
  };

  const showAskVivoHeader = () => {
    setIsAskVivoHeaderVisible(true);
  };

  return (
    <div className="flex flex-col w-full h-full items-center justify-end bg-white">
      {isAskVivoHeaderVisible && (
        <AskVivoHeader
          userInfo={userInfo as Parameters<typeof AskVivoHeader>[0]["userInfo"]}
        />
      )}

      {scope === "trial" || scope === "portfolio" ? (
        <FetchWrapper
          endpointPrefix={
            // The portfolio scope has no trial id in the URL; the backend
            // resolves the tenant's portfolio pseudo-trial itself and the
            // route absorbs the page segment the fetch hook appends.
            scope === "portfolio"
              ? "askvivo/example_questions/portfolio"
              : "askvivo/example_questions"
          }
        >
          {(data) => (
            <CategorizedQuestionsList
              questions={data}
              handleSuggestedQuestions={handleSuggestedQuestions}
              onClickExploreMore={hideAskVivoHeader}
              onCloseExploreMore={showAskVivoHeader}
            />
          )}
        </FetchWrapper>
      ) : (
        <CategorizedQuestionsList
          questions={[]}
          handleSuggestedQuestions={handleSuggestedQuestions}
          onClickExploreMore={hideAskVivoHeader}
          onCloseExploreMore={showAskVivoHeader}
        />
      )}
    </div>
  );
}
